module.exports = __webpack_public_path__ + "static/media/advasonic-4.a8b6bf9d.png";